import { Component } from '@angular/core';
import { PageBase } from '../../page.base';

import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/merge';
// SERVICES
import { StorageService } from '../../services/storage.service';
import { RequestsServices } from '../../services/requests.service';

// INTERFACES
import { IInvite } from '../../interfaces/invite';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-invite',
  templateUrl: './invite.component.html',
  providers: [RequestsServices, StorageService]
})
export class InviteComponent extends PageBase {
    private inviteData: IInvite;
    public step: string = 'step1';
    private emailOrPhone: string = '';
    private errorMessage: string = '';
    private modalityChoosen: string = 'empty';
    public options = {
      types: ['establishment'],
      componentRestrictions: { country: 'BR' }
    };

    public modalities = { 1: 'online', 2: 'físico' };

    constructor(
      private storage: StorageService,
      private request: RequestsServices,
      private userService: UserService
    ) {
      super();
     }

    private clickModality(modalityNumber) {
      this.modalityChoosen = modalityNumber;
      this.trackingEvent('seleciona-modalidade', `checkbox:${this.modalities[modalityNumber]}`);
    }

    private nextStep() {
      if (this.modalityChoosen !== 'empty') {
        this.step = 'step2';
        this.errorMessage = '';
        this.emailOrPhone = '';
        this.createInvite();

        this.trackingEvent('avançar');
      }
    }

    private sendData() {
      if (this.inviteData.phone  || this.inviteData.email) {
        this.trackingEvent('envio');
        this.emailOrPhone = '';
        this.inviteData['created_at'] = new Date();
        this.request.post('invite_logs', this.inviteData).then((response) => {
           this.step = 'step3';
           this.trackingEvent('envio-com-sucesso');
        }).catch((err) => {
          this.trackingEvent('envio-com-erro');
          this.errorMessage = 'Não foi possível enviar o convite, tente novamente mais tarde!';
        });
      } else {
        this.emailOrPhone = 'Email ou telefone obrigatório';
      }
    }

    createInvite() {
      const storageUser = this.userService.getLoggedUser();
      const activeAccount = this.userService.getLoggedAccount();

      this.inviteData = {
        companyId: activeAccount.id,
        customerId: storageUser.customerId,
        requester_name: storageUser.name,
        requester_email: storageUser.email,
        requester_company: activeAccount.name,
        establishment_name: '',
        created_at: new Date(),
        hasInvited: false,
        name: '',
        address: '',
        url_website: '',
        email: '',
        phone: ''
      };
    }

  trackingEvent(action, label?) {
    (window as any).sendEvent('admin:header', `convite:${action}`, label);
  }
}
